export { default } from './InfoTable';
